import { createSvgComponent } from "../../icon/createSvgComponent";
import Visible from "@core/__generated__/icon/figma/visible.svg";
export default createSvgComponent(Visible);